import React from 'react';

const AppPublic:React.FC<{children?: any}> = ({children}) => {
	return <>
		{children}
	</>
};

export default AppPublic;